import { type ChangeEvent, useCallback } from 'react';
import type { Lens } from '@hookform/lenses';
import { useController } from 'react-hook-form';
import { EnumSelectInput, type EnumSelectInputProps } from '@interxfi/app-components/components/enum-select-input/enum-select-input';

interface PropsWithLens<T extends string = string> extends Omit<EnumSelectInputProps<any, T>, 'name' | 'value'> {
  shouldUnregister?: boolean;
  lens: Lens<T>;
}

export function AppEnumSelectInputWithLens<T extends string = string>({ onChange, shouldUnregister, lens, ...props }: PropsWithLens<T>) {
  // TODO: remove any cast (lens library is new, doesn't support generics well yet)
  const { field, fieldState } = useController({ shouldUnregister, ...(lens.interop() as any) });
  const { onChange: fieldOnChange } = field;
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLSelectElement>) => {
      fieldOnChange(e.target.value);
      onChange?.(e);
    },
    [onChange, fieldOnChange],
  );

  return (
    <EnumSelectInput
      {...props}
      {...field}
      error={fieldState.error?.message}
      onChange={handleChange}
      touched={fieldState.isTouched}
      value={(field.value as string) || ''}
    />
  );
}
